import styled from 'styled-components';

type Props = {
  showButton: boolean;
};

export const CampaignEventsStyled = styled.div<Props>`
  .campaignEvents {
    &__container {
      background-color: ${props => props.theme.uiColors.contextSystemViewItemBackground};
      border-radius: 6px;
      display: flex;
      justify-content: ${props => (props.showButton ? 'center' : 'start')};
      padding: 16px;
    }
    
    &__selector {
      margin-top: 24px;
    }
  }
`;
